<template>
    <article class="cause-item" :id="cause.id">
        <template>
            <div class="cause-item__feature cursor-pointer" v-if="cause.img !== undefined && cause.img.length > 0"
                @click="clickHandler">
                <swiper ref="intro" :options="options">
                    <!-- <swiper-slide v-if="cause.video_url && !isDashboard">
                        <div class="cause-item__slide relative" @click="videoModelAction">
                            <img :src="videoImageUrl" loading="lazy"
                                class="absolute top-0 left-0 h-full w-full object-center object-cover" />
                            <img :src="playButton" alt="Thrive" class="absolute left-0"
                                style="height: 100px; top: 26%" />
                        </div>
                    </swiper-slide> -->
                    <swiper-slide v-for="(url, index) in getNposJson(cause.img)" :key="index">
                        <div class="cause-item__slide relative">
                            <img loading="lazy" class="absolute top-0 left-0 object-center object-cover h-full w-full"
                                :src="getNposImage(url)" :alt="getNposContent('title') || $t('Cause')" />
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
                </swiper>
            </div>
            <VideoModel :postVideoUrl="cause.video_url" @showModel="videoModelAction" v-if="showVideoModel" />
        </template>
        <!-- <template v-else>
            <div class="cause-item__feature cursor-pointer" v-if="cause.logo !== undefined" @click="clickHandler">
                <img loading="lazy" :src="getNposImage(cause.logo)" :alt="getNposContent('title') || $t('Cause')" />
            </div>
        </template> -->
        <div class="cause-item__body btn-custom">
            <header v-if="cause.title !== undefined" @click="clickHandler">
                <h2 class="cause-item__title text-text font-bold cursor-pointer text-content">
                    {{ getNposContent("title") }}
                </h2>
            </header>
            <div class="cause-item__content" v-if="cause.desc !== undefined" @click="clickHandler">
                <span v-html="truncateContent"></span>
            </div>
            <button v-if="isSelect" v-ripple type="button"
                class="cause-item__btn btn-bgr-accent text-16 font-bold text-center w-full btn-custom btn"
                @click="saveChoice">
                <span>{{ $t("Select") }}</span>
            </button>
        </div>
    </article>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import VideoModel from "../../components/Modal/VideoModel.vue";
import mixins from "../../config/mixins";

export default {
    name: "CauseItem",

    mixins: [mixins.npos],

    components: {
        Swiper,
        SwiperSlide,
        VideoModel
    },

    directives: {
        swiper: directive,
    },

    props: ["cause", "index", "clickHandler", "isSelect", "isDashboard"],

    data: function () {
        return {
            locale: this.$i18n.locale,
            options: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            },
            videoImageUrl: "",
            showVideoModel: false
        };
    },

    mounted() {
        if (this.cause.video_url) {
            var res = this.cause.video_url.split("/");
            let video_id = res.slice(-1)[0];
            this.videoImageUrl = `https://img.youtube.com/vi/${video_id}/maxresdefault.jpg`;
        }
    },
    computed: {
        playButton() {
            return `${this.$store.state.appUrl}/img/pwa/login/play-button.svg`
        },
        truncateContent: function () {
            let content = this.getNposContent("desc");
            if (content) {
                return content.substr(0, 110) + "...";
            }
            return "";
        },
    },

    methods: {
        saveChoice: function () {
            window.scrollTo(0, 0)
            this.$http
                .post("user/addnpo", { npo_id: this.cause.id })
                .then(data => {
                    if (data && data.status !== undefined && data.status) {
                        this.saveNposChoice(this.getNposContent("title"));
                        if (this.$route.path === "/login") {
                            this.$setState("showGoogleMap", false);
                            this.$setState("showSteps", true);
                            this.$setState("loginActiveStep", "bank");
                            this.$setState("loginSteps", { cause: true });
                            this.$setState("showAppFilters", false);
                        }
                    }
                });
        },
        videoModelAction: function () {
            if (this.showVideoModel) {
                this.showVideoModel = false
            } else {
                this.showVideoModel = true
            }
        },
    },
};
</script>
